module.exports = __webpack_public_path__ + "static/media/4.dee30ded.jpg";